
namespace Gamification.Gamification {

    @Serenity.Decorators.registerEditor('Gamification.Gamification.Checklist2Editor')
    export class Checklist2Editor extends Serenity.EntityGrid<ChecklistRow, any> {
        protected getColumnsKey() { return ChecklistCheckColumns.columnsKey; }
        protected getDialogType() { return ChecklistDialog; }
        protected getIdProperty() { return ChecklistRow.idProperty; }
        protected getInsertPermission() { return ChecklistRow.insertPermission; }
        protected getLocalTextPrefix() { return ChecklistRow.localTextPrefix; }
        protected getService() { return ChecklistService.baseUrl; }

        private selectedItem: ChecklistRow = null;
        private selectedRowIndex: number = null;

        constructor(container: JQuery) {
            super(container);

            this.slickGrid.setSelectionModel(new Slick.RowSelectionModel());
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 15;
            return opt;
        }

        protected getAddButtonCaption() {
            return "Aggiungi";
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slick-row-selected";
            opt.enableCellNavigation = true;
            opt.enableColumnReorder = true;

            return opt;
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);

            dialog.idAssetEsperienza = this.idAssetEsperienza;

            //var theDialog: Checklist2EditorDialog = dialog;
            //theDialog.idAssetEsperienza = this.idAssetEsperienza;
        }

        validateEntity(row, id) {
            row.IdAssetEsperienzaNome = AssetEsperienzeRow.getLookup().itemById[row.IdAssetEsperienza].Nome;

            return true;
        }

        protected createQuickSearchInput() { }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            //Add a Button
            buttons.push({
                title: 'Sposta su',
                hint: 'Sposta su',
                cssClass: 'decrementa-ordine',
                icon: 'fa-arrow-up',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.selectedRowIndex != null) {
                        if (this.selectedRowIndex > 0) {
                            //
                            var itemSelezionato = this.itemAt(this.selectedRowIndex);
                            var itemPrecedente = this.itemAt(this.selectedRowIndex - 1);
                            //
                            if (itemSelezionato.Progressivo !== itemPrecedente.Progressivo) {
                                var ordineSelezionato = itemSelezionato.Progressivo;
                                var ordinePrecedente = itemPrecedente.Progressivo;

                                itemSelezionato.Progressivo = ordinePrecedente;
                                itemPrecedente.Progressivo = ordineSelezionato;
                            }

                            //
                            this.riordinamento(itemSelezionato, itemPrecedente, true);

                            //    this.view.beginUpdate();
                            //    this.view.sortedUpdateItem(itemSelezionato.IdChecklist, itemSelezionato);
                            //    this.view.sortedUpdateItem(itemPrecedente.IdChecklist, itemPrecedente);
                            //    this.view.endUpdate();
                            //    this.view.reSort();
                            //    //
                            //    var selectedRows = this.slickGrid.getSelectedRows();
                            //    this.selectedRowIndex = this.selectedRowIndex - 1;
                            //    selectedRows[0] = this.selectedRowIndex;
                            //    this.slickGrid.setSelectedRows(selectedRows);
                            //    this.slickGrid.flashCell(this.selectedRowIndex, 1, 500);
                            //    this.slickGrid.setActiveCell(this.selectedRowIndex, 1);
                            //    //
                            //    ChecklistService.Update(
                            //        {
                            //            EntityId: itemPrecedente.IdChecklist,
                            //            Entity: itemPrecedente
                            //        },
                            //        response => {
                            //            ChecklistService.Update(
                            //                {
                            //                    EntityId: itemSelezionato.IdChecklist,
                            //                    Entity: itemSelezionato
                            //                },
                            //                response => {
                            //                    this.refresh();
                            //                },
                            //                { async: false });
                            //        },
                            //        {
                            //            async: false
                            //        }
                            //    );
                        }
                    }
                    else {
                        Q.notifyWarning("Selezionare il modulo che si desidera gestire.");
                    }
                }
            });

            //Add a Button
            buttons.push({
                title: 'Sposta giù',
                hint: 'Sposta giù',
                cssClass: 'incrementa-ordine',
                icon: 'fa-arrow-down',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.selectedRowIndex != null) {
                        if (this.selectedRowIndex < this.getItems().length - 1) {
                            //
                            var itemSelezionato = this.itemAt(this.selectedRowIndex);
                            var itemSuccessivo = this.itemAt(this.selectedRowIndex + 1);
                            //
                            if (itemSelezionato.Progressivo !== itemSuccessivo.Progressivo) {
                                var ordineSelezionato = itemSelezionato.Progressivo;
                                var ordineSuccessivo = itemSuccessivo.Progressivo;

                                itemSelezionato.Progressivo = ordineSuccessivo;
                                itemSuccessivo.Progressivo = ordineSelezionato;
                            }

                            //
                            this.riordinamento(itemSelezionato, itemSuccessivo, false);

                            //    this.view.beginUpdate();
                            //    this.view.sortedUpdateItem(itemSelezionato.IdChecklist, itemSelezionato);
                            //    this.view.sortedUpdateItem(itemSuccessivo.IdChecklist, itemSuccessivo);
                            //    this.view.endUpdate();
                            //    this.view.reSort();
                            //    //
                            //    var selectedRows = this.slickGrid.getSelectedRows();
                            //    this.selectedRowIndex = this.selectedRowIndex + 1;
                            //    selectedRows[0] = this.selectedRowIndex;
                            //    this.slickGrid.setSelectedRows(selectedRows);
                            //    this.slickGrid.flashCell(this.selectedRowIndex, 1, 500);
                            //    this.slickGrid.setActiveCell(this.selectedRowIndex, 1);
                            //    //
                            //    ChecklistService.Update(
                            //        {
                            //            EntityId: itemSuccessivo.IdChecklist,
                            //            Entity: itemSuccessivo
                            //        },
                            //        response => {
                            //            ChecklistService.Update(
                            //                {
                            //                    EntityId: itemSelezionato.IdChecklist,
                            //                    Entity: itemSelezionato
                            //                },
                            //                response => {
                            //                    this.refresh();
                            //                },
                            //                { async: false });
                            //        },
                            //        {
                            //            async: false
                            //        }
                            //    );
                        }
                    }
                    else {
                        Q.notifyWarning("Selezionare il modulo che si desidera gestire.");
                    }
                }
            });

            //
            return buttons;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && (!!this.idAssetEsperienza);
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            this.selectedItem = item;
            this.selectedRowIndex = row;
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private riordinamento(itemSelezionato: ChecklistRow, itemAltro: ChecklistRow, up: boolean) {
            this.view.beginUpdate();
            this.view.sortedUpdateItem(itemSelezionato.IdChecklist, itemSelezionato);
            this.view.sortedUpdateItem(itemAltro.IdChecklist, itemAltro);
            this.view.endUpdate();
            this.view.reSort();
            //
            var selectedRows = this.slickGrid.getSelectedRows();

            if (up)
                this.selectedRowIndex = this.selectedRowIndex - 1;
            else
                this.selectedRowIndex = this.selectedRowIndex + 1;

            selectedRows[0] = this.selectedRowIndex;
            this.slickGrid.setSelectedRows(selectedRows);
            this.slickGrid.flashCell(this.selectedRowIndex, 1, 500);
            this.slickGrid.setActiveCell(this.selectedRowIndex, 1);

            //
            ChecklistService.Update(
                {
                    EntityId: itemAltro.IdChecklist,
                    Entity: itemAltro
                },
                response => {
                    ChecklistService.Update(
                        {
                            EntityId: itemSelezionato.IdChecklist,
                            Entity: itemSelezionato
                        },
                        response => {
                            //this.refresh();
                        },
                        { async: false });
                },
                {
                    async: false
                }
            );
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _idAssetEsperienza: number;

        get idAssetEsperienza() {
            return this._idAssetEsperienza;
        }

        set idAssetEsperienza(value: number) {
            if (this._idAssetEsperienza != value) {
                this._idAssetEsperienza = value;
                this.setEquality(AssetEsperienzeRow.Fields.IdAssetEsperienza, value);
                this.refresh();
            }
        }
    }
}
